import React, { useState } from "react";
import logo from "../../assets/logo.png";
// import Button from "./Button";
import { CiMenuFries } from "react-icons/ci";
import { HiXMark } from "react-icons/hi2";
import { useLocation } from "react-router-dom";
import BtnRounded from "./BtnRounded";
import OpenCalendly from "./OpenCalendly";
import { list_services_page } from "../../data/services";
import { FaAngleRight, FaAngleDown } from "react-icons/fa";
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isServicesMobileOpen, setIsServicesMobileOpen] = useState(false);

  const location = useLocation();

  return (
    <header className="fixed bg-white min-h-[80px] z-40 justify-between items-center shadow-lg  px-4 sm:px-6 md:px-12 lg:px-16 xl:px-20 py-3 flex lg:gap-[140px]   w-full left-0 top-0 ">
      <div>
        <a href="/" className="text-customAqua200 font-extrabold text-nowrap">
          <img
            src={logo}
            alt=""
            className="object-contain  w-28 md:w-28 lg:w-40 "
          />
        </a>
      </div>
      {isOpen ? (
        <HiXMark
          onClick={() => setIsOpen(!isOpen)}
          className="  text-customAqua100 text-[24px] font-bold cursor-pointer lg:hidden block"
        />
      ) : (
        <CiMenuFries
          onClick={() => setIsOpen(!isOpen)}
          className="  text-customAqua100 text-[24px] font-bold cursor-pointer lg:hidden block"
        />
      )}
      {/* <div className={ ` hidden  w-full  lg:flex lg:justify-between text-center  items-center gap-10 left-0 transition-all duration-200`}> */}
      <div
        className={` hidden  w-full  lg:flex lg:flex-row lg:justify-end text-center  items-center gap-10 left-0 transition-all duration-200`}
      >
        <ul
          className={`w-fit flex items-center lg:gap-4 xl:gap-10 text-customAqua600 font-thin capitalize ${
            isOpen ? "flex-col gap-6" : ""
          }`}
          // onMouseLeave={() => setIsServicesOpen(false)}
        >
          <li
            className={`transition-all duration-300   hover:text-customBlue lg:text-[17px] relative after:w-0 after:transition-all after:duration-200 after:-bottom-3 after:content-[''] hover:after:w-full after:absolute after:bg-customBlue after:h-1 after:left-0 ${
              location.pathname === "/"
                ? "after:w-full text-customAqua000 "
                : "  "
            }`}
          >
            <a href="/">Accueil</a>
          </li>
          <li
            className={`transition-all duration-300  hover:text-customBlue lg:text-[17px] relative after:w-0 after:transition-all after:duration-200 after:-bottom-3 after:content-[''] hover:after:w-full after:absolute after:bg-customBlue after:h-1 after:left-0 ${
              location.pathname.includes("/services/")
                ? "after:w-full text-customAqua000"
                : "  "
            }`}
            onMouseEnter={() => setIsServicesOpen(true)}
            // onMouseLeave={() => setIsServicesOpen(false)}
          >
            <a
              href="/services"
              onClick={(e) => {
                if (true) e.preventDefault(); // Replace true with your disabled condition
              }}
            >
              Services
            </a>
            {isServicesOpen && (
              <ul
                onMouseEnter={() => setIsServicesOpen(true)}
                onMouseLeave={() => setIsServicesOpen(false)}
                className="absolute top-full left-0 mt-2 bg-white shadow-lg text-customAqua600 rounded-lg w-48 text-left"
              >
                {list_services_page.map((item, index) => (
                  <li className="px-4 py-2 hover:bg-customBlue hover:underline">
                    <a href={`/services/${item.id}`}>{item.title}</a>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li
            className={`hover:text-customBlue lg:text-[17px] relative after:w-0 after:transition-all after:duration-200 after:-bottom-3 after:content-[''] hover:after:w-full after:absolute after:bg-customBlue after:h-1 after:left-0 ${
              location.pathname === "/contact"
                ? "after:w-full text-customAqua000"
                : "  "
            }`}
          >
            <a href="/contact">Contactez-Nous</a>
          </li>
          {/* <li
            className={`hover:text-customBlue lg:text-[17px] relative after:w-0 after:transition-all after:duration-200 after:-bottom-3 after:content-[''] hover:after:w-full after:absolute after:bg-customBlue after:h-1 after:left-0 ${
              location.pathname === "/faq"
                ? "after:w-full text-customAqua000"
                : "  "
            }`}
          >
            <a href="/faq">FAQ</a>
          </li> */}
        </ul>
        <BtnRounded>
          <OpenCalendly />
        </BtnRounded>
      </div>
      {/* In  Mobile */}
      <div
        className={` absolute top-[64px] bg-customWhite left-0 h-screen overflow-hidden flex flex-col gap-8 pt-14 items-center  ${
          isOpen ? " w-full block scale-100" : " scale-0"
        }  w-full transition-all duration-200`}
      >
        <ul
          className={`w-fit items-center gap-8 flex items-centertext-white font-thin capitalize flex-col text-customAqua600`}
        >
          <li
            className={`flex flex-col ${
              location.pathname.includes("/services/")
                ? "after:w-full text-customBlue"
                : "  "
            } hover:text-customBlue lg:text-[17px] relative after:w-0 after:transition-all after:duration-200 after:-bottom-3 after:content-[''] hover:after:w-full after:absolute after:bg-customBlue after:h-1 after:left-0`}
          >
            <button className="flex flex-row items-center justify-center">
              Services
              {isServicesMobileOpen ? (
                <FaAngleDown
                  className="ml-2"
                  onClick={() => setIsServicesMobileOpen(!isServicesMobileOpen)}
                />
              ) : (
                <FaAngleRight
                  className="ml-2"
                  onClick={() => setIsServicesMobileOpen(!isServicesMobileOpen)}
                />
              )}
            </button>
            {isServicesMobileOpen && (
              <ul className="mt-2 text-customAqua600 rounded-lg w-48 text-center">
                {list_services_page.map((item, index) => (
                  <li className="px-4 py-2 hover:bg-customBlue hover:underline">
                    <a href={`/services/${item.id}`}>{item.title}</a>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li
            className={`${
              location.pathname === "/contact"
                ? "after:w-full text-customBlue"
                : "  "
            } hover:text-customBlue lg:text-[17px] relative after:w-0 after:transition-all after:duration-200 after:-bottom-3 after:content-[''] hover:after:w-full after:absolute after:bg-customBlue after:h-1 after:left-0`}
          >
            <a href="/contact">Contactez-Nous</a>
          </li>
          {/* <li
            className={`${
              location.pathname === "/faq"
                ? "after:w-full text-customBlue"
                : "  "
            } transition-all duration-300 hover:text-customBlue lg:text-[17px] relative after:w-0 after:transition-all after:duration-200 after:-bottom-3 after:content-[''] hover:after:w-full after:absolute after:bg-customBlue after:h-1 after:left-0`}
          >
            <a href="/faq">FAQ</a>
          </li> */}
        </ul>
        <BtnRounded>
          <OpenCalendly />
        </BtnRounded>
      </div>
    </header>
  );
};

export default Navbar;
